import { DIRECT_TO_DOCTOR_FORM_ID } from '@/pages/DirectToDoctorForms/DirectToDoctorForm';
import { PRESCREENING_FORM_EMAIL_LOCAL_STORAGE_KEY } from '@/pages/PreScreeningForms/PreScreeningForm';
import { getSearchParams } from '@/utils/url';
import { useState } from 'react';

export type PatientOnboardingFormAnswers = {
  fullName?: {
    firstName: string;
    lastName: string;
  };
  mobileNumber?: {
    phoneNo: string;
  };
  birthday?: string;
  address?: {
    state?: string;
  };
};

export type PatientOnboardingDetails = {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  birthday?: string;
  state?: string;
};

const getDetailsFromStorage = (): PatientOnboardingDetails | null => {
  try {
    const storedDetails = sessionStorage.getItem(DIRECT_TO_DOCTOR_FORM_ID);

    if (!storedDetails) {
      return null;
    }

    const { fullName, mobileNumber, birthday, address }: PatientOnboardingFormAnswers = JSON.parse(storedDetails) ?? {};

    const firstName = fullName?.firstName.trim();
    const lastName = fullName?.lastName.trim();
    const phoneNumber = mobileNumber?.phoneNo.trim();
    const email = getSearchParams('email', { localStorageKey: PRESCREENING_FORM_EMAIL_LOCAL_STORAGE_KEY })?.trim();

    if (!firstName || !lastName || !phoneNumber || !email) {
      return null;
    }

    return {
      firstName,
      lastName,
      phoneNumber,
      email,
      birthday: birthday?.trim() || undefined,
      state: address?.state?.trim() || undefined,
    };
  } catch {
    return null;
  }
};

export const usePatientOnboardingDetails = () => {
  const [details] = useState<PatientOnboardingDetails | null>(() => getDetailsFromStorage());

  return { patientOnboardingDetails: details };
};
